import styled, { css } from 'styled-components';
import { mediaQuery } from 'common/theme/media';

export const Tablet = css`
    .ticket {
        display: flex;
        flex-direction: column;
        padding: 15px;
        gap: 15px;
        .up {
            width: 100%;
            display: flex;
            align-items: flex-start;
            border-right: none;

            .from-to {
                margin-left: 20px;
            }
            .material-icons {
                color: var(--mui-palette-secondary-main);
                margin: 4px;
                margin-bottom: -4px;
                font-size: 16px;
            }
        }
        .down {
            width: 100%;
            display: flex;
            border-right: none;
            justify-content: space-between;
            padding: 0 15px;
            &.img {
                height: 100%;
            }

            .detail {
                display: flex;
                align-items: end;
                justify-content: flex-end;
                gap: 10px;
                flex: 1;
                &.logo-hidden {
                    justify-content: space-between;
                }
                .price {
                    font-size: 16px;
                    font-weight: 700;
                    display: flex;
                    justify-content: start;
                    align-items: end;
                    color: var(--mui-palette-secondary-main);
                    small {
                        font-weight: 600;
                        display: flex;
                        justify-content: start;
                        align-items: center;
                        margin-bottom: 6px;
                        .material-icons {
                            font-size: 14px;
                        }
                    }
                }
                .arrow {
                    width: 24px;
                    height: 24px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #eee;
                    border-radius: 100%;
                    transition: all 0.3s;
                    .material-icons {
                        font-size: 14px;
                    }
                }
            }
        }

        &::before {
            content: '';
            position: absolute;
            z-index: 1;
            left: -6px;
            top: 0;
            bottom: 0;
            margin: auto;
            width: 14px;
            height: 14px;
            border-radius: 100%;
            background-color: #efeff1;
        }
        &::after {
            content: '';
            position: absolute;
            z-index: 1;
            right: -6px;
            top: 0;
            bottom: 0;
            margin: auto;
            width: 14px;
            height: 14px;
            border-radius: 100%;
            background-color: #efeff1;
        }
        &.primary {
            .up {
                .material-icons {
                    color: var(--mui-palette-primary-main);
                }
            }
            .down {
                .detail {
                    .price {
                        color: var(--mui-palette-primary-main);
                    }
                }
            }
        }
    }
`;
export const Styled = styled.div`
    .overflow-hidden {
        overflow: hidden;
        filter: drop-shadow(4px 4px 42px rgba(0, 0, 0, 0.1));
    }
    .ticket {
        text-decoration: none;
        color: #303641;
        background-color: #fff;
        border-radius: 16px;
        display: flex;
        padding: 0;
        height: 100%;
        width: 100%;

        .left,
        .right {
            position: relative;
            &::before {
                content: '';
                position: absolute;
                z-index: 1;
                top: 0;
                bottom: 0;
                margin: auto;
                width: 14px;
                height: 14px;
                border-radius: 100%;
                background-color: #efeff1;
            }
        }
        .left {
            padding-left: 30px;
            padding-right: 15px;
            border-right: dashed 1px rgb(193 195 200 / 60%);
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            &::before {
                left: -7px;
            }
            &.logo-hidden {
                padding: 0%;
                border-right: 0;
                padding-left: 15px;
                img {
                    display: none;
                }
            }
        }
        .right {
            flex: 1;
            padding: 15px;
            padding-right: 30px;
            &::before {
                right: -7px;
            }
            .from-to {
                display: flex;
                align-items: center;
                gap: 5px;
                margin-bottom: 5px;
                color: #303641;
                font-size: 14px;
                .material-icons {
                    color: var(--mui-palette-secondary-main);
                    font-size: 16px;
                }
                & > span:not(.material-icons) {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: calc(50% - 8px);
                }
            }
            .detail {
                display: flex;
                align-items: end;
                justify-content: space-between;
                gap: 10px;

                .price {
                    font-size: 16px;
                    font-weight: 700;
                    display: flex;
                    justify-content: start;
                    align-items: end;
                    color: var(--mui-palette-secondary-main);
                    small {
                        font-weight: 600;
                        display: flex;
                        justify-content: start;
                        align-items: center;
                        margin-bottom: 6px;
                        .material-icons {
                            font-size: 14px;
                        }
                    }
                }
                .arrow {
                    width: 24px;
                    height: 24px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #eee;
                    border-radius: 100%;
                    transition: all 0.3s;
                    .material-icons {
                        font-size: 14px;
                    }
                }
            }
        }
        &.primary {
            .right {
                .from-to .material-icons {
                    color: var(--mui-palette-primary-main);
                }
                .detail {
                    .price {
                        color: var(--mui-palette-primary-main);
                    }
                }
            }
        }
    }
    ${mediaQuery.lessThan('xltablet')`${Tablet}`}
`;
